import React, { Component } from "react";

export default class TOS extends Component {
  render() {
    return (
      <div id="TOS">
        <section className="TOS" data-section="TOS">
          <div className="col-md-12 text-center">
            <h1 className="heading">Terms of Service ("Terms")</h1>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Agreement to Terms of Service</h2>
            <p>
              Please read these Terms of Service ("Terms", "Terms of Service")
              carefully before using the <em><a href="/">Double The Fun</a></em>{" "}
              website and any of the mobile applications (the "Services") operated by{" "}
              <em>Double The Fun</em> ("us", "we", or "our"). Your
              access to and use of the Service is conditioned on your acceptance
              of and compliance with these Terms. These Terms apply to all
              visitors, users and others who access or use the Service. By
              accessing or using the Service you agree to be bound by these
              Terms. If you disagree with any part of the terms then you may not
              access the Service.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Termination</h2>
            <p>
              We may terminate or suspend access to our Service immediately,
              without prior notice or liability, for any reason whatsoever,
              including without limitation if you breach the Terms. All
              provisions of the Terms which by their nature should survive
              termination shall survive termination, including, without
              limitation, ownership provisions, warranty disclaimers, indemnity
              and limitations of liability.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Content</h2>
            <p>
              All text, graphics, user interfaces, visual interfaces,
              photographs, trademarks, logos, sounds, music, artwork and
              computer code (collectively, "Content"), including but not limited
              to the design, structure, selection, coordination, expression,
              "look and feel" and arrangement of such Content, contained on the
              Site and all of the apps are owned, controlled or licensed by or to{" "}
              <em>Double The Fun</em>.
            </p>
            <p>
              Except as expressly provided in these Terms of Service, no part of
              the Site and any of the apps may be copied, reproduced, republished, uploaded, posted,
              publicly displayed, encoded, translated, transmitted or
              distributed in any way (including "mirroring") to any other
              computer, server, Web site or other medium for publication or
              distribution or for any commercial enterprise, without{" "}
              <em>Double The Fun</em> express prior written consent.
            </p>
            <p>
              You may only use information purposely made available by{" "}
              <em>Doubl The Fun</em> for downloading from the Site and
              on any of the apps, provided that you (1) not remove any proprietary notice
              language in all copies of such documents, (2) use such information
              only for your personal, non-commercial informational purpose and
              do not copy or post such information on any networked computer or
              broadcast it in any media, (3) make no modifications to any such
              information, and (4) not make any additional representations or
              warranties relating to such documents.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Your Use of the Service</h2>
            <p>
              You may not use any "deep-link", "page-scrape", "robot", "spider"
              or other automatic device, program, algorithm or methodology, or
              any similar or equivalent manual process, to access, acquire, copy
              or monitor any portion of the Service or any Content, or in any
              way reproduce or circumvent the navigational structure or
              presentation of the Service or any Content, to obtain or attempt
              to obtain any materials, documents or information through any
              means not purposely made available through the Service. We
              reserves the right to bar any such activity.
            </p>
            <p>
              You may not attempt to gain unauthorized access to any portion or
              feature of the Service, or any other systems or networks connected
              to the Service, or to any of the services offered on or through
              the Service, by hacking, password "mining" or any other
              illegitimate means.
            </p>
            <p>
              You may not use the Service for any purpose that is unlawful or
              prohibited by these Terms of Service, or to solicit the
              performance of any illegal activity or other activity which
              infringes the rights of <em>Double The Fun</em> or others.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Links To Other Web Sites</h2>
            <p>
              Our Service may contain links to third-party web sites or services
              that are not owned or controlled by{" "}
              <em>Double The Fun</em>.  <em>Double The Fun</em>{" "}
              has no control over, and assumes no responsibility for, the
              content, privacy policies, or practices of any third party web
              sites or services. You further acknowledge and agree that{" "}
              <em>Double The Fun</em> shall not be responsible or
              liable, directly or indirectly, for any damage or loss caused or
              alleged to be caused by or in connection with use of or reliance
              on any such content, goods or services available on or through any
              such web sites or services.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Mobile In-App Purchases</h2>
            <p>
              Our Service may include in-app purchases that allow you to buy
              things such as virtual currency, items, lives, or boosters, etc.
              ("In-App Purchases"). You acknowledge and agree that you are fully
              responsible for managing your In-App Purchases and the amount you
              spend on In-App Purchases offered by our Service.
            </p>
            <p>
              If you are under 18 then you mush have your parents' or guardians'
              permission to make any In-App Purchases. By completing an In-App
              Purchase, you are confirming to us that you have any and all
              permission that may be necessary in order to allow you to make
              that In-App Purchase.
            </p>
            <p>
              If any In-App Purchase is not successfully downloaded or does not
              work once it has been successfully downloaded, we will, after
              becoming aware of the fault or being notified of the fault by ou,
              investigate the reason for the fault. We will act reasonably in
              deciding whether to provide you with a replacement In-App Purchase
              or issue you with a patch to repair the fault. In no event will we
              charge you anything further to replace or replair the In-App
              Purchase. In the unlikely event that we are unable to replace o
              repair the relevant In-App Purchase or are unable to do so within
              a reasonable period of time and without significant inconvenience
              to you, we will authorise the App Store Provider to refund you an
              amount up to the cost of the relevant In-App Purchase.
              Alternatively, if you wish to request a refund, you may do so by
              contacting the App Store Provider directly.
            </p>
            <p>
              You acknowledge and agree that all billing and transaction
              processes are handled by the App Store Provider from whose
              platform you downloaded the mobile App and are governed by the App
              Store Provider's terms and conditions/EULA. If you have any
              payment related issues with the In-App Purchases then you need to
              contact the App Store Provider directly.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Changes</h2>
            <p>
              <em>Double The Fun</em> may make changes to any products
              or services offered on the Site and any of the Apps, or to the 
              applicable prices for any such products or services, at any time, 
              without notice. The materials on the Site and all of the apps with 
              respect to products and services may be out of date, and{" "}
              <em>Double The Fun</em> makes no commitment to update the
              materials with respect to such products and services.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Accounts and Security</h2>
            <p>
              Certain features or services offered on or through the Service may
              require you to open an account. You are entirely responsible for
              maintaining the confidentiality of the information you hold for
              your account, including your password, and for any and all
              activity that occurs under your account as a result of your
              failing to keep this information secure and confidential. You
              agree to notify <em>Doublev The Fun</em> immediately of any
              unauthorized use of your account or password, or any other breach
              of security. You may be held liable for losses incurred by{" "}
              <em>Double The Fun</em> or any other user of the Service
              due to someone else using your account as a result of your failing
              to keep your account information secure and confidential.
            </p>
          </div>
          <div className="col-md-12">
            <h2 className="heading">Disclaimers</h2>
            <p>
              <em>Double The Fun</em> DOES NOT PROMISE THAT THE SITE OR
              ANY CONTENT, SERVICE OR FEATURE OF THE SITE WILL BE ERROR-FREE OR
              UNINTERRUPTED, OR THAT ANY DEFECTS WILL BE CORRECTED, OR THAT YOUR
              USE OF THE SERVICE WILL PROVIDE SPECIFIC RESULTS. THE SERVICE AND
              ITS CONTENT ARE DELIVERED ON AN "AS-IS" AND "AS-AVAILABLE" BASIS.
              ALL INFORMATION PROVIDED BY THE SERVICE IS SUBJECT TO CHANGE
              WITHOUT NOTICE. <em>Double The Fun</em> CANNOT ENSURE THAT
              ANY FILES OR OTHER DATA YOU DOWNLOAD WILL BE FREE OF VIRUSES OR
              CONTAMINATION OR DESTRUCTIVE FEATURES.{" "}
              <em>Double The Fun</em> DISCLAIMS ALL WARRANTIES, EXPRESS
              OR IMPLIED, INCLUDING ANY WARRANTIES OF ACCURACY,
              NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR
              PURPOSE. <em>Double The Fun</em> DISCLAIMS ANY AND ALL
              LIABILITY FOR THE ACTS, OMISSIONS AND CONDUCT OF ANY THIRD PARTIES
              IN CONNECTION WITH OR RELATED TO YOUR USE OF THE SITE AND/OR ANY{" "}
              <em>Double The Fun</em> SERVICES. YOU ASSUME TOTAL
              RESPONSIBILITY FOR YOUR USE OF THE SERVICE. YOUR SOLE REMEDY
              AGAINST <em>Doubl The Fun</em> FOR DISSATISFACTION WITH
              THE SERVICE IS TO STOP USING THE SERVICE. THIS LIMITATION OF
              RELIEF IS A PART OF THE BARGAIN BETWEEN THE PARTIES.
            </p>
          </div>
        </section>
      </div>
    );
  }
}
